import { Skeleton } from '@/components/ui/skeleton';

export const CollectionSkeleton = () => {
  return (
    <div className='w-full space-y-6'>
      <div className='animate-pulse space-y-4'>
        {/* Collection Header */}
        <div className='space-y-4'>
          <div className='flex items-center justify-between'>
            <div>
              <Skeleton className='h-8 w-64' />
            </div>
            <Skeleton className='h-9 w-16' />
          </div>

          {/* Description */}
          <Skeleton className='h-16 w-full' />
        </div>

        {/* Search and Action Buttons */}
        <div className='flex items-center justify-between mb-6'>
          <div className='flex items-center gap-2 w-96'>
            <div className='relative flex-1'>
              <Skeleton className='h-10 w-full' />
            </div>
          </div>
          <div className='flex items-center gap-2'>
            <Skeleton className='h-9 w-9' />
            <Skeleton className='h-9 w-24' />
          </div>
        </div>

        {/* Files count section */}
        <div className='space-y-4'>
          <div className='flex items-center justify-between'>
            <Skeleton className='h-6 w-24' />
          </div>

          {/* Table */}
          <div className='border rounded-lg overflow-hidden'>
            {/* Table Header */}
            <div className='grid grid-cols-[3fr_2fr_1fr_1fr_2fr_60px] gap-4 p-3 bg-muted/50 border-b'>
              <Skeleton className='h-4 w-16' /> {/* Name */}
              <Skeleton className='h-4 w-24' /> {/* Indexing status */}
              <Skeleton className='h-4 w-12' /> {/* Type */}
              <Skeleton className='h-4 w-12' /> {/* Size */}
              <Skeleton className='h-4 w-20' /> {/* Last Modified */}
              <div className='w-16' /> {/* Actions */}
            </div>

            {/* Table Body */}
            <div className='divide-y'>
              {[1, 2, 3, 4, 5, 6, 7, 8].map((index) => (
                <div
                  key={index}
                  className='grid grid-cols-[3fr_2fr_1fr_1fr_2fr_60px] gap-4 p-3 items-center'
                >
                  {/* Name */}
                  <Skeleton className='h-4 w-48' />

                  {/* Indexing status */}
                  {/* <Skeleton className='h-6 w-20 rounded-full' /> */}

                  {/* Type */}
                  <Skeleton className='h-4 w-16' />

                  {/* Size */}
                  <Skeleton className='h-4 w-12' />

                  {/* Last Modified */}
                  <Skeleton className='h-4 w-20' />

                  {/* Actions */}
                  <div className='flex justify-end'>
                    <Skeleton className='h-8 w-8 rounded-md' />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
